import React from 'react';
import QuoteRequestForm, { BrochureBtn, VideoButton, ImgRender } from '../../BFComponents';

const CanonIpf770 = () => {
    return (
        <div className="container">
            <ImgRender image={"prograf-banner.jpg"} width={100} />
            <div className="row">
                <div className="col-md-6">
                    <ImgRender image={"ipf770.jpg"} width={100} />
                </div>
                <div className="col-md-6 p-4">
                    <ImgRender image={"ipf770.svg"} width={50} />
                    <h4>Introducing the 36-inch wide imagePROGRAF iPF770
and 24-inch iPF670 Large-Format Printers.</h4>
                    <p>Affordable printers for those looking for an entry-level,
multipurpose, large-format printer.</p><p>Designed for low-volume printing,
                    these printers offer affordable
                    solutions that can support a variety
                    of applications including: posters,
                    presentations, technical documents,
                    drawings, company announcements,
enlargements, and more.</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"Canon imagePROGRAF iPF770.pdf"} />
                    <VideoButton id={"V1k4t47qOaEM"} />
                    <h4 className="ipfblueheader">FEATURES</h4>
                    <h5 className="ipforangeheader">AVAILABLE WORKFLOW SOLUTIONS</h5>
                    <ul>
                        <li>Mobile printing app</li>
                        <li>Direct Print & Share</li>
                        <li>PosterArtist Lite</li>
                        <li>Print Plug-in for Microsoft Office®, and more</li>
                    </ul>
                    <h5 className="ipforangeheader">INK</h5>

                    <ul>
                        <li>A reformulated Magenta ink</li>
                        <li>A Sub-Ink Tank System</li>
                    </ul>
                    <h5 className="ipforangeheader">PRINT SPEED</h5>
                    <ul>
                        <li>Capable of producing an A1 (23.39" x 33.11") print,
in about 25 seconds on the iPF770</li>
                    </ul>
                    <h5 className="ipforangeheader">DESKTOP DESIGN</h5>
                    <ul>
                        <li> iPF670 model available without stand</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h5 className="ipforangeheader">INK SYSTEM</h5>

                    <ul>
                        <li>The 5-Color ink set found in the imagePROGRAF
                        iPF770 and iPF670 large-format printers is ideal for
                        technical applications, posters, and office signage.
                        This ink technology uses four highly colorfast dye inks
                        for producing bold, expressive color, plus two channels
                        of pigment matte black ink for printing precise lines,
                        smooth curves, and small text on technical and office
                        documents. Included is a reformulated magenta ink,
                        that helps produce a wider color gamut in the red and
orange spectrums, compared to previous models.</li>
                        <li>The printer’s sub-ink tank system allows for all of
                        the available ink in a tank to be used before needing to
                        replace it, helping eliminate any wasted ink. The empty
tanks can also be replaced without stopping a print job.</li>
                    </ul>
                    <h5 className="ipforangeheader">LOW OPERATIONAL COST</h5>
                    <ul>
                        <li>A number of important built-in features help minimize
                        ink consumption, media waste, and maintenance costs
                        to help reduce total cost of operation. These features
                        include Economy Print Mode for low cost per print,
auto-rotation, and nesting to minimize media waste.</li>
                    </ul>
                    <h5 className="ipforangeheader">SPACE SAVING DESIGN</h5>
                    <ul>
                        <li>The printers have a small footprint with fully frontaccessible operation for flush wall installation, to fit into
almost any environment. There is also an assisted toploading feature for easy media loading.</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h5 className="ipforangeheader">VERSATILITY</h5>
                Enhancements to the line-up of imagePROGRAF
software solutions can help improve printing workflow
and management.
<br /><br /><strong>
                        imagePROGRAF Print Utility<br /></strong>
This iOS-based app allows users to print PDF files
wirelessly, directly from an iPad® to an imagePROGRAF
printer.
<br /><br /><strong>Direct Print & Share 2.0<br /></strong>
Canon’s cloud-based portal solution allows for the
sharing and printing of JPG, TIFF, PDF, and HP-GL/2
files from almost anywhere in the world. Also,
shortcut-printing capability has been added for
drag-and-drop printing (PC only).
<br /><br /><strong>PosterArtist Lite<br /></strong>
Poster creation software gives you all the tools you’ll
need to design and output impressive large-format signs
and banners (PC only).
Print Plug-in for Microsoft Office
Allows for users of any skill level to print posters or
banners directly from Microsoft® Excel®, PowerPoint®,
and Word®.
<br /><br /><strong>Accounting Manager<br /></strong>
Help keep track of costs and allocate consumable
expenses to projects easily. This management tool
allows you to track print jobs by user to calculate ink
and media (PC only).
<br /><br /><strong>imageRUNNER Enlargement Copy<br /></strong>
Scan-to-Print using an imageRUNNER or imagePRESS
device to an imagePROGRAF iPF770/670 printer (PC only).
                </div>
            </div>

        </div>
    )
}

export default CanonIpf770;